/**
 * @generated SignedSource<<493243528ade0deddaa0f17548d2d63a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type header_nativeIssueTable$data = {
  readonly " $fragmentSpreads": FragmentRefs<"insertColumnButton_nativeIssueTable_InsertColumnButtonInner">;
  readonly " $fragmentType": "header_nativeIssueTable";
};
export type header_nativeIssueTable$key = {
  readonly " $data"?: header_nativeIssueTable$data;
  readonly " $fragmentSpreads": FragmentRefs<"header_nativeIssueTable">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "header_nativeIssueTable",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "insertColumnButton_nativeIssueTable_InsertColumnButtonInner"
    }
  ],
  "type": "JiraIssueSearchViewMetadata",
  "abstractKey": "__isJiraIssueSearchViewMetadata"
};

(node as any).hash = "e49a5c95264b2ec1daf94b87c16f86ba";

export default node;
